// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"762":"1469c0d3","787":"18830742","977":"da4db474"}[chunkId] + ".chunk.js";
};